import React from 'react';
import { useColorMode } from '../context/ColorModeContext';

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="4" fill="currentColor" />
      <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
        <line x1="12" y1="2.5" x2="12" y2="5.2" />
        <line x1="12" y1="18.8" x2="12" y2="21.5" />
        <line x1="2.5" y1="12" x2="5.2" y2="12" />
        <line x1="18.8" y1="12" x2="21.5" y2="12" />
        <line x1="5.4" y1="5.4" x2="7.2" y2="7.2" />
        <line x1="16.8" y1="16.8" x2="18.6" y2="18.6" />
        <line x1="18.6" y1="5.4" x2="16.8" y2="7.2" />
        <line x1="7.2" y1="16.8" x2="5.4" y2="18.6" />
      </g>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <path
        d="M19.4 14.1a7.2 7.2 0 0 1-9.6-9.6 8.4 8.4 0 1 0 9.6 9.6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function ColorModeToggle({ className = '' }) {
  const { isDay, toggleColorMode } = useColorMode();
  const nextLabel = isDay ? 'Switch to night theme' : 'Switch to day theme';

  return (
    <button
      type="button"
      className={['color-mode-toggle', 'color-mode-toggle--icon', className].filter(Boolean).join(' ')}
      onClick={toggleColorMode}
      aria-label={nextLabel}
      title={nextLabel}
    >
      {isDay ? <MoonIcon /> : <SunIcon />}
    </button>
  );
}
